import React from 'react';

export default function KakaoCancel() {
    return <div className="text-4xl">결제 취소</div>;
}
